import React from "react";
import AccordionItem from "./AccordionItem";

const Menu = () => {
  // Menu categories with 5 items each
  const menuCategories = [
    {
      categoryName: "Breakfast",
      items: [
        {
          name: "OLD SCHOOL",
          price: "₵65.0",
          description: "Oats,Toast and 2 Eggs.",
        },
        {
          name: "LITE ENGLISH",
          price: "₵100.0",
          description:
            "An egg to your taste, one sausage, bacon, grilled tomato, baked beans and sautéed mushrooms",
        },
        {
          name: "THE BREAKFAST WRAP",
          price: "₵100.0",
          description:
            "Our classic veggie omelets, bacon bits, mushrooms, cheddar & mozzarella cheese. Served with sauteed potatoes",
        },
        {
          name: "AMERICAN",
          price: "₵120.0",
          description:
            "4 ﬂuffy pancakes, maple syrup, scrambled eggs and two bacon rashers. Add fruit juice, tea, coffee or water. *(Replace bacon with beef patty or chicken sausages)",
        },
        {
          name: "FULL ENGLISH",
          price: "₵170.0",
          description:
            "2 eggs to your taste, 2 pork sausages, bacon rashers, grilled tomato, sautéed mushrooms,baked beans & toast. Add fruit juice, tea, coffee or water. *(Replace pork / bacon with beef patty or chicken sausages)",
        },
      ],
    },
    {
      categoryName: "Lunch",
      subCategory: "Rice",
      items: [
        {
          name: "EGG FRIED RICE",
          price: "₵75.0",
          description: "",
        },
        {
          name: "VEGGIE FRIED RICE (V)",
          price: "₵65.0",
          description: "",
        },
        {
          name: "CHICKEN FRIED RICE",
          price: "₵95.0",
          description: "",
        },
        {
          name: "BEEF FRIED RICE",
          price: "₵100.0",
          description: "",
        },
        {
          name: "SEAFOOD FRIED/JOLLOF RICE",
          price: "₵200.0",
          description: "",
        },
      ],
    },
    {
      categoryName: "Drinks",
      items: [
        {
          name: "LANATUS FIX",
          price: "₵90.0",
          description:
            "Is a cocktail made to appreciate the beautiful women in Ghana, malibu, apple vodka, melon liquor, pineapple juice, sweet and sour apple syrup",
        },
        {
          name: "S. O. K",
          price: "₵100.0",
          description:
            "Cocktail best enjoyed in a hot atmosphere made with rum, banana liquor, pineapple juice and lemon juice, green melon liquor",
        },
        {
          name: "PURPLE SUMMER",
          price: "₵100.0",
          description:
            "Is a cocktail named by color, if consists of apple vodka, pineapple juice and soda water, malibu, grenadine, blue curacao syrup",
        },
        {
          name: "SERENE SONG",
          price: "₵130.0",
          description:
            "Is a cocktail based on ifs loud name and is a colorful strong and sweet mix. If is made up of vodka blue curaçao, melon liquor, pineapple juice malibu, grenadine with dark rum.",
        },
        {
          name: "JAMES THE GUY GUY",
          price: "₵110.0",
          description:
            "Is a whiskey based cocktail, which the name comes from this loyal customer, who is a jameson whiskey lover, it consists of jameson whiskey, lemon juice, simple syrup, egg white and topped with ginger beer",
        },
      ],
    },
  ];

  return (
    <section id="menu" className="sm:mb-[4rem] xs:mb-[2rem]">
      <h2 className="text-deepRed italic text-center font-bold volkhov md:text-[46px] sm:text-[35px] text-[25px] md:mt-[70px] mt-[50px] ">
        Our Menu
      </h2>

      <div className="flex items-center flex-col justify-center xs:gap-[30px] md:mt-[100px] xs:mt-[50px] mt-[20px]">
        <img src="/images/menu-logo.svg" alt="menu_logo" />
        <p className="max-w-[550px] text-center text-warning sm:leading-[28px] leading-[25px] sm:text-[18px] text-[17px] mb-[38px] px-[1rem]">
          from full breakfast to a wide range of carefully selected lunch &
          dinner meal options fused with some of the popular local cuisine.
        </p>
      </div>

      <div className="flex items-center gap-[2rem]">
        <img
          src="/images/flower.svg"
          alt="flower__image"
          className="mb-[-120px] md:w-[200px] w-[150px]  sm:flex hidden"
        />

        <div className="flex lg:flex-row lg:px-0 sm:px-[2rem] flex-col gap-[3rem] px-[1rem]">
          <div className="xl:ml-[150px] lg:ml-[50px] ml-0">
            <div className="grid xs:grid-cols-2 gap-12 justify-between h-[65vh] overflow-auto scroll__bar pr-[1.5rem]">
              {/* Static Menu Categories */}
              {menuCategories?.map((category, categoryIndex) => {
                return (
                  <div key={`category-${categoryIndex}`}>
                    <div className="flex gap-[12px] mb-[32px]">
                      <p className="text-lightGreen text-[24px] italic volkhov mt-[10px]">
                        {category.categoryName}
                      </p>
                    </div>
                    {category.subCategory && (
                      <div className="flex gap-[12px] mb-[20px]">
                        <p className="text-warning text-[18px] italic volkhov">
                          {category.subCategory}
                        </p>
                      </div>
                    )}
                    {category.items?.map((item, itemIndex) => {
                      return (
                        <AccordionItem
                          key={`${category.categoryName.toLowerCase()}-${itemIndex}`}
                          titleColor={"lightGreen"}
                          priceColor={"lightRed_100"}
                          title={item.name}
                          price={item.price}
                          content={item.description}
                        />
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>

          <img
            src="/images/menu-img.svg"
            alt=""
            className="xl:w-[600px] lg:w-[400px] sm:w-[500px] w-full lg:h-[70vh] h-full"
          />
        </div>

        {/* Explore More Menu Button - Outside menu grid */}
      </div>
      <div className="flex justify-center mt-[60px] mb-[40px]">
        <a
          href="https://menu.starbitesgh.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-[50px] gap-[5px] lg:px-[20px] px-[15px] py-[9px] cursor-pointer border text-lightRed_100 lg:text-[18px] text-[15px] inter leading-[30px] hover:bg-lightRed_100 hover:text-white transition-all duration-300 font-[600]"
        >
          Explore Menu
        </a>
      </div>
    </section>
  );
};

export default Menu;
